import type { TupleToUnion } from "type-fest";

export const locales = [
  "en-US",
  "es-ES",
  "fa-IR",
  "fr-FR",
  "hi-IN",
  "ja-JP",
  "ko-KR",
  "pt-BR",
  "uk-UA",
  "zh-CN",
] as const;

export type Locale = TupleToUnion<typeof locales>;
